
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Image from 'next/image';
import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import React from 'react';
import CallToAction from '@/components/CallToAction';
import FaqTranscription from '@/components/FaqTranscription';
import FeaturedLogos from '@/components/FeaturedLogos';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import LogosCloud from '@/components/LogosCloud';
import Seo from '@/components/Seo';
import Testimonials from '@/components/Testimonials';
import TranscriptionFeaturesSimple from '@/components/TranscriptionFeaturesSimple';
const NoteTaker = () => {
    const { t, lang } = useLocale('ai-transcription');
    return (<main className='relative bg-gray-100 dark:bg-slate-900'>
      <Seo templateTitle={t('AI Note Taker | Meetings, Sales Calls, Lectures & More')} description={t('Record any conversation and instantly get AI-powered transcription, summaries, and actionable insights. Perfect for meetings, sales calls, lectures, and coaching sessions.')} image={`https://easy-peasy.ai/api/og-template?title=${t('Never Miss a Detail with AI Recording')}`}/>
      <div className='relative bg-white dark:bg-slate-900'>
        <div className='mx-auto'>
          <div className='relative z-10 bg-white pb-8 dark:bg-slate-900 lg:w-full'>
            <div className='relative bg-white dark:bg-slate-900'>
              <div className='mx-auto'>
                <LandingPageNavigation />
                <main className='mx-auto mt-10 flex justify-center px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 2xl:mt-28'>
                  <div className='text-center'>
                    <h1 className='flex justify-center text-4xl font-extrabold tracking-tight text-gray-900 dark:text-slate-200 sm:text-5xl lg:text-6xl'>
                      <div className='flex max-w-4xl flex-col items-center justify-center'>
                        <div className='mx-auto mb-4 w-fit rounded-full bg-indigo-500/10 px-3 py-1 text-sm font-semibold leading-6 tracking-wide text-primary-600 ring-1 ring-inset ring-indigo-500/20'>
                          {t('All-In-One AI Platform')}
                        </div>
                        <div className='bg-gradient-to-r from-primary-600 to-pink-600 bg-clip-text pb-5 text-transparent'>
                          {t('Never Miss a Detail with AI Recording')}
                        </div>
                      </div>
                    </h1>
                    <p className='mx-auto flex max-w-3xl justify-center text-xl text-gray-500 sm:text-2xl'>
                      {t('Record any conversation and let AI transform it into actionable insights')}
                    </p>
                    <div className='mt-5 sm:mt-10 sm:flex sm:justify-center'>
                      <div>
                        <div className='rounded-md shadow'>
                          <Link href='/presets/note-taker' className='flex w-full items-center justify-center rounded-md border border-transparent bg-primary-600 px-8 py-3 text-base font-medium text-white hover:bg-primary-700 md:px-10 md:py-4 md:text-lg'>
                            {t('Start Recording')}
                          </Link>
                        </div>
                        <div className='mt-5 flex items-center justify-center space-x-4'>
                          <div className='flex -space-x-3 overflow-hidden'>
                            <Image src='/images/ankita.png' alt='' width='32' height='32' className='inline-block h-8 w-8 rounded-full border-[2px] border-indigo-400'/>
                            <Image src='/images/dmytro.jpg' alt='' width='32' height='32' className='inline-block h-8 w-8 rounded-full border-[2px] border-indigo-400'/>
                            <Image src='/images/marianna_ole.jpeg' alt='' width='32' height='32' className='inline-block h-8 w-8 rounded-full border-[2px] border-indigo-400'/>
                          </div>
                          <p className='mx-auto max-w-lg text-sm text-gray-500 lg:mx-0'>
                            <strong>876,388+</strong> {t('happy users')}
                          </p>
                          <div className='flex'>
                            {[...Array(5)].map((_, i) => (<svg key={i} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' className='h-4 w-4 text-yellow-400'>
                                <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
                              </svg>))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='mt-10 flex w-full justify-center gap-x-4 gap-y-2 text-center text-gray-500 dark:text-slate-400 lg:text-lg'>
                      <div>🎙️ {t('One-click recording')}</div>
                      <div>📝 {t('Instant transcription')}</div>
                      <div>✨ {t('AI-powered insights')}</div>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LogosCloud />
      <div className='py-24 sm:py-32 lg:pb-40'>
        <div className='mx-auto max-w-7xl px-6 text-center lg:px-8'>
          <h2 className='mx-auto mt-2 max-w-3xl bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 bg-clip-text text-center text-3xl font-bold tracking-tight text-transparent sm:text-4xl'>
            {t('Record Once, Get Multiple Insights')}
            <br />
            {t('Powered by Advanced AI')}
          </h2>
          <p className='mx-auto mt-5 max-w-prose text-xl text-gray-500 dark:text-slate-400'>
            {t('Perfect for professionals who need to capture and analyze conversations')}
          </p>
          <div className='mt-16 flow-root'>
            <div className='-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4'>
              <Image src='/images/transcription2.png' alt='AI Recording Interface' width={2432} height={1442} className='rounded-md shadow-2xl ring-1 ring-gray-900/10'/>
            </div>
          </div>
          <h2 className='mx-auto mt-20 max-w-3xl bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 bg-clip-text text-center text-3xl font-bold tracking-tight text-transparent sm:text-4xl'>
            {t('AI-Powered Analysis')}
            <br />
            {t('For Every Conversation')}
          </h2>
          <p className='mx-auto mt-5 max-w-2xl text-xl text-gray-500 dark:text-slate-400'>
            {t('Get transcripts, summaries, action items, and key insights automatically generated')}
          </p>
          <div className='mt-16 flow-root'>
            <div className='-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4'>
              <Image src='/images/transcription-chatgpt.png' alt='AI Analysis Interface' width={2432} height={1442} className='rounded-md shadow-2xl ring-1 ring-gray-900/10'/>
            </div>
          </div>
          <div className='mt-10'>
            <h2 className='mx-auto mt-20 max-w-3xl bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 bg-clip-text text-center text-3xl font-bold tracking-tight text-transparent sm:text-4xl'>
              {t('Perfect For Every Professional Need')}
            </h2>
            <div className='mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3'>
              <div className='h-full rounded-xl bg-gray-900/5 p-6 ring-1 ring-inset ring-gray-900/10 hover:bg-gray-100 dark:bg-slate-800 dark:hover:bg-slate-700'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-slate-200'>
                  <Link href='/ai-transcription/meeting'>
                    {t('Business Meetings')}
                  </Link>
                </h3>
                <p className='mt-2 text-gray-500 dark:text-slate-400'>
                  {t('Capture decisions, action items, and key discussion points')}
                </p>
              </div>
              <div className='h-full rounded-xl bg-gray-900/5 p-6 ring-1 ring-inset ring-gray-900/10 hover:bg-gray-100 dark:bg-slate-800 dark:hover:bg-slate-700'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-slate-200'>
                  {t('Sales Calls')}
                </h3>
                <p className='mt-2 text-gray-500 dark:text-slate-400'>
                  {t('Track customer needs, objections, and follow-up items')}
                </p>
              </div>
              <div className='h-full rounded-xl bg-gray-900/5 p-6 ring-1 ring-inset ring-gray-900/10 hover:bg-gray-100 dark:bg-slate-800 dark:hover:bg-slate-700'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-slate-200'>
                  {t('Lectures & Training')}
                </h3>
                <p className='mt-2 text-gray-500 dark:text-slate-400'>
                  {t('Convert educational content into structured notes and summaries')}
                </p>
              </div>
              <div className='h-full rounded-xl bg-gray-900/5 p-6 ring-1 ring-inset ring-gray-900/10 hover:bg-gray-100 dark:bg-slate-800 dark:hover:bg-slate-700'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-slate-200'>
                  {t('Coaching Sessions')}
                </h3>
                <p className='mt-2 text-gray-500 dark:text-slate-400'>
                  {t('Document progress, insights, and action plans for clients')}
                </p>
              </div>
              <div className='h-full rounded-xl bg-gray-900/5 p-6 ring-1 ring-inset ring-gray-900/10 hover:bg-gray-100 dark:bg-slate-800 dark:hover:bg-slate-700'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-slate-200'>
                  {t('Interviews')}
                </h3>
                <p className='mt-2 text-gray-500 dark:text-slate-400'>
                  {t('Get detailed transcripts with speaker detection and key points')}
                </p>
              </div>
              <div className='h-full rounded-xl bg-gray-900/5 p-6 ring-1 ring-inset ring-gray-900/10 hover:bg-gray-100 dark:bg-slate-800 dark:hover:bg-slate-700'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-slate-200'>
                  {t('Podcasts & Webinars')}
                </h3>
                <p className='mt-2 text-gray-500 dark:text-slate-400'>
                  {t('Transform long-form content into searchable, shareable formats')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TranscriptionFeaturesSimple />
      <FeaturedLogos />
      <FaqTranscription />
      <Testimonials />
      <CallToAction preset='note-taker'/>
      <Footer />
    </main>);
};
export default NoteTaker;

    async function __Next_Translate__getStaticProps__1a0cbfb66c9__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-note-taker',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0cbfb66c9__ as getStaticProps }
  